module.exports = function(msklepApp) {
    msklepApp.directive('floatingBox', ['$window', '$timeout', function ($window, $timeout) {
            return {
                link: function (scope, element, attrs) {
                    scope.$window = $window;
                    $timeout((function () {
                        let w = angular.element(scope.$window);
                        let fixed = false;
                        let position = attrs.floatingBox;
                        let offset = attrs.offset ? parseInt(attrs.offset) : 0;
                        let relative = !!(attrs.relative && attrs.relative === 'true');
                        let child = element.children();

                        switch (position) {
                            case 'bottom':
                                element.css({height: element[0].offsetHeight + 'px'});
                                w.bind('scroll', () => {
                                    if (!fixed && element[0].getBoundingClientRect().bottom >= w[0].innerHeight) {
                                        element.addClass('outside-view');
                                        fixed = true;
                                    } else if (fixed && element[0].getBoundingClientRect().bottom < w[0].innerHeight) {
                                        element.removeClass('outside-view');
                                        fixed = false;
                                    }
                                });
                                break;
                            case 'top':
                                w.bind('scroll', () => {
                                    if (!fixed && element[0].getBoundingClientRect().top - offset <= 0) {
                                        element.addClass('outside-view');
                                        fixed = true;
                                    } else if (fixed && element[0].getBoundingClientRect().top - offset > 0) {
                                        element.removeClass('outside-view');
                                        fixed = false;
                                    }
                                    if (relative && fixed) {
                                        if (Math.abs(element[0].getBoundingClientRect().top - offset) + child[0].offsetHeight <= element[0].offsetHeight) {
                                            child.css({top: Math.abs(element[0].getBoundingClientRect().top - offset) + 'px'});
                                        } else {
                                            child.css({top: (element[0].offsetHeight - child[0].offsetHeight) + 'px'});
                                        }
                                    } else if (relative) {
                                        child.css({top: '0'});
                                    }
                                })
                        }

                        w.triggerHandler('scroll');
                    }), 100);
                }
            }
        }]
    );
}
